<template>
  <div class="layout">
    <el-container class="layout-body">
      <AppHeader class="header" />
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script setup>
import AppHeader from '@/components/UI/AppHeader.vue'
</script>
